export default __webpack_public_path__ + "static/nodejs-e525044cbef408f871f8a1a6bfb52d66.svg";